<template>
  <div v-if="isAuthenticated && (downloadAssets.length || downloadUrl)" class="mt-8">
    <VcTypography tag="h2" class="mb-4">{{ $t("shared.catalog.product_details.downloads_block_title") }}</VcTypography>
    <div class="flex flex-col flex-wrap md:flex-row">
      <div v-for="asset in downloadAssets" :key="asset.id" class="text-15 mt-5 flex items-center md:w-1/3">
        <div class="line-clamp-3 flex w-fit flex-col text-left font-bold" :title="asset.url">
          <!-- Innovadis custom: XSS fix - sanitize href URL to prevent javascript: URL injection (AIKIDO) -->
          <a :href="getSafeUrl(encodeUrl(asset.url))" target="_blank" download class="text-primary hover:underline">
            <VcIcon v-if="isPdfFile(asset.url)" name="pdf" :size="25" class="mr-3" />
            <VcIcon v-else name="arrow-circle-down" :size="25" class="mr-3 text-secondary" />
          </a>
        </div>
        <div class="flex w-full flex-col">
          <!-- Innovadis custom: XSS fix - sanitize href URL to prevent javascript: URL injection (AIKIDO) -->
          <a :href="getSafeUrl(encodeUrl(asset.url))" target="_blank" download class="flex shrink flex-col">
            <strong class="capitalize">{{ asset.group }}</strong>
            <span class="text-neutral-500">{{ asset?.name }}</span>
          </a>
        </div>
      </div>

      <div v-if="downloadUrl" class="text-15 mt-5 flex items-center md:w-1/3">
        <div class="line-clamp-3 flex w-fit flex-col text-left font-bold">
          <!-- Innovadis custom: XSS fix - sanitize href URL to prevent javascript: URL injection (AIKIDO) -->
          <a :href="getSafeUrl(downloadUrl)" target="_blank" class="text-primary hover:underline">
            <VcIcon name="globe-alt" :size="25" class="mr-3 text-secondary" />
          </a>
        </div>
        <div class="flex w-full flex-col">
          <!-- Innovadis custom: XSS fix - sanitize href URL to prevent javascript: URL injection (AIKIDO) -->
          <a :href="getSafeUrl(downloadUrl)" target="_blank" class="flex shrink flex-col">
            <strong class="capitalize">{{ $t("custom.product_details.product_page_url") }}</strong>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useUser } from "@/shared/account";
import { getSafeUrl } from "@/core/utilities";
import type { PropType } from "vue";

type AssetType = {
  id: string;
  name?: string;
  url: string;
  group?: string;
};

const props = defineProps({
  downloadUrl: {
    type: String,
    default: "",
  },
  assets: {
    type: Array as PropType<AssetType[]>,
    default: () => [],
  },
});

const { isAuthenticated } = useUser();

const isPdfFile = (url: string): boolean => {
  return url.toLowerCase().endsWith(".pdf");
};

function encodeUrl(url: string) {
  return url.replace(/\+/g, "%2B");
}

const downloadAssets = computed(() => props.assets.filter((a: AssetType) => a.group != "Images"));
</script>
